import { useParams, useNavigate } from 'react-router-dom';
import { Button, Card, Spin, message, theme } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/PageHeader';
import { PlanForm } from './components/PlanForm';
import { usePlan, useUpdatePlan } from './api/usePlanes';
import { useHasPermission } from '../../auth/useHasPermission';
import { EmptyState } from '../../components/EmptyState';
import { Permission } from '@aid/shared';

export function PlanEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const planId = Number(id);
  const { data: plan, isLoading, error } = usePlan(planId);
  const updatePlan = useUpdatePlan();
  const hasPermission = useHasPermission(Permission.PLANES_UPDATE);
  const { token } = theme.useToken();

  if (!hasPermission) {
    return <div>No tienes permiso para editar planes.</div>;
  }

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || !plan) {
    return (
      <EmptyState
        title="Plan no encontrado"
        description="El plan que intentas editar no existe o fue eliminado."
      />
    );
  }

  const handleSubmit = async (values: Record<string, unknown>) => {
    try {
      await updatePlan.mutateAsync({ id: plan.id, dto: values });
      message.success('Plan actualizado correctamente');
      navigate(`/planes/${plan.id}`);
    } catch {
      message.error('Error al actualizar el plan');
    }
  };

  return (
    <div>
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(`/planes/${plan.id}`)}
        style={{ paddingLeft: 0, height: 'auto', marginBottom: 8 }}
      >
        Volver al plan
      </Button>
      <PageHeader title="Editar plan" subtitle={plan.nombre ?? `#${plan.id}`} />
      <Card
        style={{
          borderRadius: 12,
          border: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: token.boxShadow,
        }}
      >
        <PlanForm
          mode="edit"
          initialValues={plan}
          onSubmit={handleSubmit}
          loading={updatePlan.isPending}
        />
      </Card>
    </div>
  );
}
